module.exports = __webpack_public_path__ + "img/australianChemistryOlympiad.8d35aef4.png";